export enum SearchUsage {
	ProductsShopCard,
	ProductsSearch,
	WardrobeItemsUserCard,
	WardrobeItemsOuttfitSearch,
	// WardrobeItemsJobWorkOutfit,
	OutfitWardrobeItems,
}
